// Whether a dealer is on a vendor platform (Sera), from its tblDealerOnboard rows
// (GET /dealer/{id}/onboard). The same test as jbwnewonboarding and jbwcreatepotentialclaim:
// vendorId set, or crmSystem 'Sera' in any case.
//
// tblDealer.crmSystem cannot answer this. Its column default is 'ServiceTitan' and only
// jbwnewonboarding changes it to 'Sera', so a vendor dealer whose tblDealerOnboard row was
// inserted by hand still reads ServiceTitan there.
//
// A row with no vendorId and any other crmSystem reads as not a vendor. The setup guide's own
// INSERT has that shape unless the app is named "Sera". It is left out on purpose: treating every
// unknown crmSystem as a vendor would hide ServiceTitan screens from a real dealer on a bad value.
export const isVendorDealer = (onboardRows) =>
  Array.isArray(onboardRows) &&
  onboardRows.some(
    (row) => row?.vendorId != null || String(row?.crmSystem || "").toLowerCase() === "sera"
  );
